<template>
    <div class="discuss-page">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <div v-if="shareData.cansave != 1" class="comment-fate-topbar discuss-fate-topbar">
            <!-- 1、顶部菜单栏 -->
            <div class="comment-title-bar dsp-flex">
                <div class="comment-title-side">
                    <span v-if="fromEmbedded" class="discuss-title-back" @click="clickClose">
                        <i class="iconfont icon-guanbi"></i>
                    </span>
                    <span v-else class="comment-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                </div>
                <div class="comment-title-mid" @click="toggleName">
                    <span v-if="hideName">匿名</span>
                    <span v-else>{{detailInfo.f_name}}</span>
                </div> 
                <div class="comment-title-side" v-if="fromEmbedded" @click="clickShare">
                    <span class="comment-title-save">分享</span>
                </div>
            </div>
            <!-- 2、迷你:命盘+运盘组件 -->
            <mini-fate-fortune-panel
                v-bind:fromPage="pageName">
            </mini-fate-fortune-panel>
        </div>

        <!-- 聊天记录列表 -->
        <discuss-history-list v-if="shareData.cansave != 1"></discuss-history-list>

        <!-- 聊天输入框 -->
        <discuss-bottom-bar v-if="hasLogined && shareData.cansave != 1 && lunpanData.isEnd != 1"></discuss-bottom-bar>

        <!-- 提示分享蒙层 -->
        <div class="layout-overlay" v-if="isNewLunPan && showNewSharePop && !fromEmbedded && CONFIG.platform != 'web'">
            <div class="discuss-share-note">
                <p v-if="CONFIG.platform == 'wechat'">转发到微信群<br />邀请大家进入论盘</p>
                <p v-if="CONFIG.platform == 'qq'">转发到QQ群<br />邀请大家进入论盘</p>
                <div class="discuss-share-btn" @click="clickKnow">知道了</div>
            </div>
        </div>

        <!-- 提示打开浮窗弹框 -->
        <div id="floatPopOverlay" class="layout-overlay layout-overlay-blank" v-if="shareData.cansave != 1 && showDiscussFloatPop && !fromEmbedded" @click="clickDiscussFloatOverLay"></div>
        <discuss-float-pop v-if="shareData.cansave != 1 && showDiscussFloatPop && !fromEmbedded"></discuss-float-pop>
                
        <!-- 录音上滑操作提示 -->
        <div class="discuss-voice-operate-tips" v-if="showVoiceOperateTips">
            <div class="discuss-vot-top dsp-flex">
                <div class="discuss-vott-left">
                    <i class="iconfont icon-micro"></i>
                </div>
            </div>
            <div class="discuss-vot-bottom dsp-flex">
                <div class="discuss-votb-left"><i class="iconfont icon-back"></i></div>
                <div class="discuss-votb-mid">上滑取消或转文字</div>
                <div class="discuss-votb-right"><i class="iconfont icon-wen"></i></div>
            </div>
        </div>

        <!-- 录音取消or转文字操作框 -->
        <div class="discuss-voice-operate-panel" v-if="showVoiceOperatePanel">
            <div class="discuss-vop-content">
                <div class="discuss-vop-icon"><i class="iconfont icon-micro"></i></div>
                <div class="discuss-vop-note">松开手指，取消发送</div>
            </div>
            <div class="discuss-vop-bottom dsp-flex">
                <div class="discuss-vop-item discuss-vop-item-left">
                    <button class="discuss-vop-button discuss-vop-button-cancel"><i class="iconfont icon-back"></i><br>取消</button>
                </div>
                <div class="discuss-vop-item discuss-vop-item-right">
                    <button class="discuss-vop-button discuss-vop-button-wen"><i class="iconfont icon-wen"></i><br>转文字</button>
                </div>
            </div>
        </div>

        <!-- 弹框:修改论盘名称 -->
        <van-dialog v-model="showDiscussEditPop" v-bind:title="'修改论盘名称'" v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" placeholder="请输入论盘名称" v-model="inputLunPanName" maxlength="25" autofocus />
            </div>
        </van-dialog>

        <!-- 子页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import DiscussHistoryList from '../../layouts/discuss/DiscussHistoryList.vue'
import DiscussBottomBar from '../../layouts/discuss/DiscussBottomBar.vue'
import DiscussFloatPop from '../../layouts/discuss/DiscussFloatPop.vue'
import { DISCUSS_DOM } from '../../modules/dom'
import { SCHEME, UA } from '../../modules/utils'
import { SHARE } from '../../modules/share'
import { WS } from '../../modules/websocket'
import { DATA } from '../../modules/data'
import { CONFIG } from '../../modules/config'
export default {
    name: 'Discuss',
    components: {MiniFateFortunePanel, DiscussHistoryList, DiscussBottomBar, DiscussFloatPop},
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        detailInfo() {
            return this.$store.state.discuss.detailInfo;
        },
        isNewLunPan() {
            return this.$store.state.discuss.isNewLunPan;
        },
        hasLogined() {
            return this.$store.state.discuss.hasLogined;
        },
        hideName() {
            return this.$store.state.discuss.hideName;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        shareData() {
            return this.$store.state.othershare.shareData;
        },
        showDiscussEditPop: {
            get() {
                return this.$store.state.discuss.showDiscussEditPop;
            },
            set(value) {
                this.$store.state.discuss.showDiscussEditPop = value;
            }
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            pageName: 'Discuss',
            showVoiceOperateTips: false,
            showVoiceOperatePanel: false,
            inputLunPanName: '',
            showDiscussFloatPop: false,
            showNewSharePop: true
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            DISCUSS_DOM.updateDiscussPageStyle();
            DISCUSS_DOM.updateDiscussFormStyle();
            me.checkDiscussStatus();
        }, 20);

        setTimeout(() => {
            me.inputLunPanName = me.lunpanData.title;
        }, 1000);

        window.onresize = function() {
            setTimeout(() => {
                DISCUSS_DOM.updateDiscussPageStyle();
            }, 20);
        }
    },
    created: function() {
        var curPath = this.$router.history.current.path;
        if(curPath.indexOf('/embedded/discuss') == -1 && curPath.indexOf('/share/discuss') == -1 && !this.detailInfo.id) {
            this.$router.replace('/record');
            return;
        }
    },
    methods: {
        checkDiscussStatus() {
            // 在非微信端不显示
            // if(!UA.isWeChat()) {
            //     return;
            // }
            // function handler(event) {  event.preventDefault();}

            var me = this;
            if(!this.isNewLunPan || (this.isNewLunPan && !this.showNewSharePop)) {
                this.showDiscussFloatPop = true;
                setTimeout(() => {
                    // 绑定事件
                    // document.addEventListener('touchmove', handler, false);
                    me.bindOverlayEvent();
                }, 100);
                // 定时隐藏
                setTimeout(() => {
                    me.showDiscussFloatPop = false;
                    setTimeout(() => {
                        me.unbindOverlayEvent();
                        me.bindListUploadEvent();
                    }, 20);
                }, 5000);
            }

            // 解绑事件
            // function handler(event) {  event.preventDefault();}
            // document.removeEventListener('touchmove', handler, false);
        },
        bindOverlayEvent() {
            var me = this,
                floatDiv = document.getElementById('floatPopOverlay');
            if(floatDiv == null) { return; }
            floatDiv.addEventListener('touchstart', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.addEventListener('touchmove', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.addEventListener('touchend', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
        },
        unbindOverlayEvent() {
            var me = this,
                floatDiv = document.getElementById('floatPopOverlay');
            if(floatDiv == null) { return; }
            floatDiv.removeEventListener('touchstart', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.removeEventListener('touchmove', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.removeEventListener('touchend', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
        },
        bindListUploadEvent() {
            var me = this,
                discussListDiv = document.getElementById('DiscussList');
            // console.log('mounted---------', discussListDiv)
            if(discussListDiv) {
                discussListDiv.addEventListener('touchend', function(event) {
                    // console.log('touchend-------', discussListDiv.scrollTop)
                    if(discussListDiv.scrollTop <= 0) {
                        me.$store.state.discuss.lunpanRefreshing = true;
                        var lunpanGetAll = me.$store.state.discuss.lunpanGetAll;
                        console.log('下拉刷新::::::', lunpanGetAll)

                        setTimeout(() => {
                            if(lunpanGetAll) {
                                // 已经拉取完了就不要再拉了～
                                me.$store.state.discuss.lunpanRefreshing = false;
                            }else {
                                me.$store.dispatch('discuss/refreshHistoryMsgList');
                            }
                        }, 500);
                    }
                })
            }
        },
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('embedded/resetData');
        },
        clickBack() {
            var me = this,
                curPath = this.$router.history.current.path,
                params = this.$router.history.current.params;
            // 从分享页面来的 && 未保存为自己的:返回到列表页
            if(curPath.indexOf('share/discuss') > 0) {
                // 主动断掉ws
                WS.closeWebSocket();
                // 重置数据:
                this.$store.dispatch("discuss/resetLunPanData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.dispatch('detail/resetData');
                this.$router.replace('/record');
                return;
            }
            // 主动断掉ws
            WS.closeWebSocket();
            // 重置数据:
            this.$store.dispatch("discuss/resetLunPanData");
            this.$store.dispatch("minifatefortune/resetMiniData");

            // 跳转到论盘列表页面:::如果没有拉取列表的话，重置列表
            if(!this.gotLunPanList) {
                this.$store.dispatch('discuss/initLunPanList', this.detailInfo)
            }
            setTimeout(() => {
                me.$router.replace('/discusslist/' + this.detailInfo.id);
                if(!this.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 100);
        },
        toggleName() {
            this.$store.state.discuss.hideName = !this.$store.state.discuss.hideName;
            var me = this;
            setTimeout(() => {
                // 设置微信JSSDK分享
                if(!this.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 100);
        },
        clickShare() {
            var lunpanTitle = DATA.getLunPanShareTextByData('wechat', this.lunpanData.title, this.detailInfo);
            var shareId = this.hideName ? this.lunpanData.shareCode.nmlpshare : this.lunpanData.shareCode.smlpshare;
            SCHEME.configLunPanShare(lunpanTitle, shareId);
        },
        clickKnow() {
            // 隐藏分享提示
            this.showNewSharePop = false;
            this.checkDiscussStatus();
        },
        /**
         * 初始化声音操作面板dom
         */
        initVoiceOperateDom() {
            var bgDiv = document.getElementsByClassName('discuss-voice-operate-panel')[0];
            if(bgDiv) {
                bgDiv.style.width = innerWidth + 'px';
                bgDiv.style.height = innerHeight + 'px';
                bgDiv.style.overflow = 'hidden';
            }
        },
        beforeClose(action, done) {
            // window.scrollTo(0, 0);
            var me = this;
            if (action === 'confirm') {
                if(this.inputLunPanName != ''){
                    // 名称不为空
                    if(this.inputLunPanName == this.lunpanData.title){
                        this.$toast("名称未改变");
                        done();
                        return;
                    }
                    this.$store.dispatch('discuss/editLunPanData', {
                        id: this.lunpanData.id,
                        f_title: this.inputLunPanName,
                        cb: function(){
                            me.lunpanData.title = me.inputLunPanName;
                            me.$toast("修改论盘名称成功");
                            setTimeout(() => {
                                window.scrollTo(0, 0);
                                SHARE.initConfigShare();
                            }, 20);
                        }
                    })
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },
        clickDiscussFloatOverLay() {
            this.showDiscussFloatPop = false;
            this.unbindOverlayEvent();
        }
    }
}
</script>